/* eslint-disable no-unused-vars */
import React, { ReactNode } from 'react';
import style from './adminList.module.scss';
import Pagination from 'components/pagination/pagination';
import { useAppSelector } from 'store/hooks';
import { selectTotal, selectUsers } from 'store/admin/adminSlice';
import { Skeleton } from '@mui/material';
import { selectImagesLimit } from 'store/page/pageSlice';

export default function AdminList({
  children,
  text,
}: {
  text: string;
  children?: ReactNode;
}) {
  const users = useAppSelector(selectUsers);
  const total = useAppSelector(selectTotal);
  const imagesLimit = useAppSelector(selectImagesLimit);

  return (
    <div className={style.container}>
      {users === null ? (
        <Skeleton
          className={'notFoundtext'}
          variant="text"
          width={150}
          height={22}
        />
      ) : (
        <span className={'notFoundtext'}>{text}</span>
      )}
      <div className={style.list}>{children}</div>
      {children && (
        <Pagination
          className={style.disableMargin}
          total={total ? Math.ceil(total / imagesLimit) : undefined}
        ></Pagination>
      )}
    </div>
  );
}
